// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_STROLLERS_FROM_BRAND_brand = "Ko\u010d\u00e1rky %(brand)s";
export const STROLLER_SEO_GENERAL_DESC = "Velk\u00e1 datab\u00e1ze ko\u010d\u00e1rk\u016f Modr\u00e9ho kon\u00edka";
